import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Home from './Home';
import About from './About';
import Portfolio from './Portfolio';
import Contact from './Contact';
import NotFound from './NotFound';

import './App.css';

function AppShell() {
    const location = useLocation();
    const isHome = location.pathname === '/';

    return (
            <div className={`App${isHome ? ' App--home' : ''}`}>
                <a className="skipLink" href="#main-content">Skip to content</a>
                <Navigation />
                <main id="main-content" tabIndex="-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
            </div>
    );
}

function App() {
    return (
        <Router>
            <AppShell />
        </Router>
    );
}

export default App;
